export const DEFAULT_REQUEST: Record<string, string | number> = {
  PageSize: '36',
  filter_format: 'v2',
  apiVersion: '6',
  currency: 'INR',
  country_code: 'IN',
  deviceType: 'WEBSITE',
  sort: 'popularity',
};

export const API_REQUEST_PAYLOAD = [
  'PageSize',
  'filter_format',
  'apiVersion',
  'currency',
  'country_code',
  'deviceType',
  'searchTerm',
  'categoryId',
  'sort',
  'enable_pr',
];

export const API_KEYS = {
  FILTER: 'filter',
  PRICE_FILTER: 'price_filter',
  SORT_FILTER: 'sort',
  PRICE_REVEAL: 'enable_pr',
  PAGE_NUMBER: 'currentPage',
  SEARCH_TERM: 'searchTerm',
  CATEGORY_ID: 'categoryId',
  OFFER_ID: 'offer_id',
  COUPON_OFFER_ID: 'coupon_offer_id',
  CATALOG_TAG_FILTER: 'catalog_tag_filter',
};

export const QUERY_PARAMS = {
  FILTER: 'f',
  SEARCH: 'q',
  CATEGORY_ID_PATTERN: '/c/',
  PAGE_NUMBER: 'p',
  OFFER_ID_PATTERN: '/op/',
  DYNAMIC_PAGE: '/dp/',
  SEARCH_PATTERN: '/catalogsearch/result/',
};

export const ERROR_CONSTANTS = {
  ERROR: 'MANDATORY_RESPONSE_EMPTY',
  MAKE_PAYLOAD_METHOD: 'makePayload',
  IDENTIFIER: 'PLP',
  ERROR_MESSAGE_INVALID_KEY: `Provide atleast one required field ['searchTerm', 'categoryId']`,
};

export const FILTER_KEYS = {
  PAGE_SIZE: 'PageSize',
  SORT: 'sort',
};

export const ANALYTICS = {
  KEY_JOIN: ':',
  VALUE_JOIN: ',',
};

export const ESCAPE_FILTERS = [FILTER_KEYS.PAGE_SIZE, FILTER_KEYS.SORT];

export const FILTER_QUERY_CHARS = {
  FILTERS_SEPARATOR: ';',
  FILTER_ASSIGNMENT: '=',
  FILTER_VALUES_JOIN: '_',
  PRICE_VALUES_JOIN: '@',
  PRICE_PAYLOAD_JOIN: '-',
};

export const VECTOR_SEARCH_ALGO = 'vectorSearch';

export const USER_RANKING_ALGO = 'userRanking';
